import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(
        Rect,
        {
          width: "15.56",
          height: "15.56",
          x: "12",
          y: "1",
          rx: "2.41",
          transform: "rotate(45 12 1)",
          stroke: `${color}`
        }
      )
    }
  );
};
Icon.displayName = "Diamond";
const Diamond = memo(themed(Icon));
export {
  Diamond
};
//# sourceMappingURL=diamond.js.map
